import React from 'react';

import TableDisplay from './TableDisplay';

import {Data} from '../services/data-manager';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';
import { notifyDanger, notifySuccess } from '../utils';
import Notification from 'react-notify-toast';
import { droitsAcces, modesPaiementMobile, pays } from '../config/globales';
import ReactToPrint from 'react-to-print';

class Utilisateurs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            utilisateurs: [],
            page: 1,
            nbUtilisateur: 1,
            sizeUtilisateur: 50,
            utilisateur: null,
            showDetail: false,
            showUtilisateur: false,
            showNewUtilisateur: false,
            approvisionnement: {
                idClient: 0,
                idUtilisateur: 0,
                montant: 0,
                devise: "",
                credential: "",
                nomUtilisateur: ""
            },
            partenaires: [],
            newUtilisateur: {
                nom: "",
                prenom: "",
                nomUtilisateur: null,
                sexe: "Homme",
                dateNaissance: null,
                piece: null,
                numeroPiece: null,
                pays: "",
                devise: "",
                region: "",
                ville: "",
                adresse: "",
                email: "",
                telephone: "",
                commentaire: "",
                type: 0,
                pass: "",
                estNouveau: 0,
                estBloque: 0,
                estConnecte: true,
                langue: "fr",
                solde: 0,
                notifyAllTransaction: true,
                newsLetter: true,
                idUtilisateur: 0,
                conditionUtilisation: true,
                idPartenaire: 0,
                hasCashOut: 1,
                hasCashIn: 1,
                actif: 1
            },
            recherche: {
                motCle: "",
                tri: ""
            },
            enTraitement: false,
            actions: []
        };
        this.getUtilisateurs = this.getUtilisateurs.bind(this);
        this.getDetailUtilisateur = this.getDetailUtilisateur.bind(this);
        this.approvisionneUtilisateur = this.approvisionneUtilisateur.bind(this);
        this.getApprovisionnementUtilisateur = this.getApprovisionnementUtilisateur.bind(this);
        this.handleInputUtilisateur = this.handleInputUtilisateur.bind(this);
        this.handleInputNewUtilisateur = this.handleInputNewUtilisateur.bind(this);
        this.activerUtilisateur = this.activerUtilisateur.bind(this);
        this.desactiverUtilisateur = this.desactiverUtilisateur.bind(this);
        this.saveNewUtilisateur = this.saveNewUtilisateur.bind(this);
        this.showDetailModal = this.showDetailModal.bind(this);
        this.showApprovisionnementModal = this.showApprovisionnementModal.bind(this);
        this.showNewUtilisateurModal = this.showNewUtilisateurModal.bind(this);
        this.handleRechercheForm = this.handleRechercheForm.bind(this);
        this.handleInputRecherche = this.handleInputRecherche.bind(this);
        this.getPartenaires = this.getPartenaires.bind(this);
    }
    componentDidMount() {
        this.props.isLoading(true);
        this.getUtilisateurs();
        let actions = [];
        if ((this.props.auth.utilisateur.type>=10 && this.props.auth.utilisateur.type<20) || (this.props.auth.utilisateur.type>=30 && this.props.auth.utilisateur.type<40)) {
            actions.push({caption: <i className='fa fa-list'></i>, className:"btn btn-sm btn-primary mr-1", onClick:this.getDetailUtilisateur});
        }
        if ((this.props.auth.utilisateur.type>=20 && this.props.auth.utilisateur.type<30) || (this.props.auth.utilisateur.type>=40)) {
            actions.push({caption: <i className='fa fa-list'></i>, className:"btn btn-sm btn-primary mr-1", onClick:this.getDetailUtilisateur});
            actions.push({caption: <i className='fa fa-plus'></i>, className:"btn btn-sm btn-primary", onClick:this.getApprovisionnementUtilisateur});
        }
        this.setState({actions: actions});
        this.getPartenaires();
    }
    getUtilisateurs(page=0) {
        if (page!==0) {
            this.setState({page: page});
        } else {
            page = this.state.page;
        }
        this.props.isLoading(true);
        let sOrder = "dateCreation DESC";
        if (this.state.recherche.tri!="") {
            sOrder = this.state.recherche.tri;
        }
        // Condition du component (pour le menu concerné)
        let sCondition = (this.props.isClients)?"type=0":"type>0";
        // Condition sur l'utilisateur connecté
        if (this.props.isClients && this.props.auth.utilisateur.type<30) {
            sCondition += ` AND pays="${this.props.auth.utilisateur.pays}"`;
        }
        // Condition de recherche
        if (this.state.recherche.motCle!="") {
            let motCle = this.state.recherche.motCle;
            motCle = motCle.toUpperCase();
            const tMotCle = motCle.replace(/'|,/g, " ").split(" ");
            let sAddCondition = "";
            for(const mot of tMotCle) {
                sAddCondition += ` AND (UPPER(nom) LIKE "%${mot}%" OR UPPER(prenom) LIKE "%${mot}%" OR devise="${mot}" OR UPPER(pays)="${mot}" OR UPPER(ville)="${motCle}")`;
            }
            sCondition += sAddCondition;
        }
        new Data()
        .get("Utilisateur", sCondition, (this.props.isClients)?"":"partenaire", sOrder, page, this.state.sizeUtilisateur)
        .then(res => {
            this.setState({utilisateurs: res.rows, nbUtilisateur: res.count});
            this.props.isLoading(false);
        })
        .catch(err => {
            console.warn("Error : ", err);
            this.props.isLoading(false);
        });
        window.scrollTo(0,0);
    }
    getDetailUtilisateur(utilisateur) {
        this.setState({utilisateur: utilisateur}, () => {
            this.showDetailModal();
        });
    }
    getPartenaires() {
        new Data().get("Partenaire")
        .then(partenaires => {
            if (partenaires.rows) {
                this.setState({partenaires: partenaires.rows});
            }
        });
    }
    getApprovisionnementUtilisateur(utilisateur) {
        let approvisionnement = this.state.approvisionnement;
        approvisionnement.credential = this.props.auth.getCredential();
        approvisionnement.idUtilisateur = this.props.auth.utilisateur.id;
        approvisionnement.nomUtilisateur = utilisateur.nom + " " + utilisateur.prenom;
        approvisionnement.idClient = utilisateur.id;
        approvisionnement.devise = utilisateur.devise;
        this.setState({approvisionnement: approvisionnement}, () => {
            this.showApprovisionnementModal();
        });
    }
    approvisionneUtilisateur(e) {
        e.preventDefault();
        new Data()
        .exec("/approvisionnement", this.state.approvisionnement)
        .then(res => {
            if (res.code==200) {
                notifySuccess(res.message);
            } else {
                notifyDanger(res.message);
            }
            this.getUtilisateurs(this.state.page);
        });
        this.showApprovisionnementModal(false);
    }

    handleInputUtilisateur(event) {
        let target = event.target;
        const name = target.name;
        const value = target.value;
        let approvisionnement = this.state.approvisionnement;
        approvisionnement[name] = value;
        this.setState({approvisionnement: approvisionnement});
    }

    handleInputNewUtilisateur(event) {
        let target = event.target;
        const name = target.name;
        let value = target.value;
        if (target.type=="checkbox") {
            value = target.checked ? 1 : 0;
        }
        let newUtilisateur = this.state.newUtilisateur;
        newUtilisateur[name] = value;
        if (name=="pays") {
            let paysChoisi = pays.filter(p => (p.name==value));
            if (paysChoisi.length>0) newUtilisateur.devise = paysChoisi[0].devise;
        }
        this.setState({newUtilisateur: newUtilisateur});
    }

    handleInputRecherche(event) {
        let target = event.target;
        const name = target.name;
        const value = target.value;
        let recherche = this.state.recherche;
        recherche[name] = value;
        this.setState({recherche: recherche});
    }
    
    saveNewUtilisateur(event) {
        event.preventDefault();
        this.setState({enTraitement: true});
        new Data()
        .exec("/utilisateur", this.state.newUtilisateur)
        .then(res => {
            this.showNewUtilisateurModal(false);
            notifySuccess("Utilisateur enregistré !");
            this.getUtilisateurs(this.state.page);
        })
        .catch(err => {
            notifyDanger("Erreur lors de l'enregistrement de l'utilisateur.");
        })
        .finally( () => {
            this.setState({enTraitement: false});
        });
    }

    activerUtilisateur() {
        new Data()
        .update("Utilisateur", {actif: 1, estBloque: 1}, "id="+this.state.utilisateur.id)
        .then(res => {
            this.getUtilisateurs(this.state.page);
            if (res) notifySuccess("Utilisateur activé.");
            else notifyDanger("L'activation de l'utilisateur à échouée.");
        });
        this.showDetailModal(false);
    }

    desactiverUtilisateur() {
        new Data()
        .update("Utilisateur", {actif: 0, estBloque: 0}, "id="+this.state.utilisateur.id)
        .then(res => {
            this.getUtilisateurs(this.state.page);
            if (res) notifySuccess("Utilisateur activé.");
            else notifyDanger("L'activation de l'utilisateur à échouée.");
        });
        this.showDetailModal(false);
    }

    showDetailModal(show=true) {
        this.setState({showDetail: show});
    }
    showApprovisionnementModal(show=true) {
        this.setState({showUtilisateur: show});
    }
    showNewUtilisateurModal(show=true) {
        this.setState({showNewUtilisateur: show});
    }
    cancelUtilisateur(utilisateur) {
        window.confirm("Voulez vous vraiment supprimer la utilisateur "+utilisateur.idUtilisateur);
    }

    handleRechercheForm(event) {
        event.preventDefault();
        this.getUtilisateurs(this.state.page);
    }

    render() {
        return (
            <div className="container-fluid">
                <Notification options={{top: "100px"}} />
                <div className="row">
                    <div className="col-sm-12 my-3">
                        <div className="border p-3">
                            <form className="row" onSubmit={this.handleRechercheForm}>
                                <div className="col-6 col-md-6">
                                    <input className="form-control" name="motCle" placeholder="Recherche (nom, prénom, devise)" value={this.state.recherche.motCle} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-4 col-sm-5 col-md-4">
                                    <select className="form-control" name="tri" value={this.state.recherche.motCle} onChange={this.handleInputRecherche}>
                                        <option value="">Ordre de tri</option>
                                        <option value="nom ASC, prenom ASC">Ordre croissant de nom</option>
                                        <option value="nom DESC, prenom DESC">Ordre décroissant de nom</option>
                                        <option value="dateCreation ASC">Ordre croissant de date d'inscription</option>
                                        <option value="dateCreation DESC">Ordre décroissant de date d'inscription</option>
                                    </select>
                                </div>
                                <div className="col-2 col-sm-1 col-md-2">
                                    <button className="btn btn-secondary btn-block" type="submit">
                                        <span className="d-none d-md-inline">Rechercher</span>
                                        <span className="d-inline d-md-none">...</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="row" ref={(myRef) => {this.printableToPDF = myRef}}>
                    <div className="col-sm-12 col-md-8 my-3">
                        <h3>
                            {(this.props.isClients)?"Clients":"Utilisateurs"} 
                            [Page {this.state.page}/{(this.state.nbUtilisateur===0)?1:Math.ceil(this.state.nbUtilisateur/this.state.sizeUtilisateur)}]
                        </h3>
                        
                        {
                            ((this.state.recherche.motCle!="") || (this.props.auth.utilisateur.type>=10 && this.props.auth.utilisateur.type<30)) &&
                            <h5>
                                Filtre : 
                                {(this.state.recherche.motCle!="")?<span> {this.state.recherche.motCle.toUpperCase()}, </span>:""}
                                {(this.props.auth.utilisateur.type>=10 && this.props.auth.utilisateur.type<30) &&
                                <span> {this.props.auth.utilisateur.pays.toUpperCase()}</span>
                                }
                            </h5>
                        }
                    </div>
                    <div className="col-sm-12 col-md-4 text-right my-0 my-md-3">
                        <ReactToPrint 
                            filename="africpay-transactions.pdf"
                            content={() => this.printableToPDF}
                            trigger={() => <button className="btn btn-secondary">Imprimer</button>}
                        />
                        <button type="button" className="btn btn-primary ml-1" onClick={() => {this.showNewUtilisateurModal(true)}}>Ajouter un {(this.props.isClients)?"client":"utilisateur"}</button>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <TableDisplay 
                            tableStriped={true}
                            tableHover={true}
                            thead="dark"
                            titles={["ID", "NOM", "PRENOM", "SOLDE", "DEVISE", "DATE ENREGISTREE"]}
                            indices={["id", "nom", "prenom", "solde", "devise", "dateCreation"]}
                            data={this.state.utilisateurs}
                            actions={this.state.actions}
                            withPaging={true}
                            pagingTheme="primary"
                            nb={this.state.nbUtilisateur}
                            size={this.state.sizeUtilisateur}
                            current={this.state.page}
                            onChangePage= {this.getUtilisateurs}
                            withFooter={true} />
                    </div>
                </div>
                {(this.state.utilisateur) &&
                <Modal show={this.state.showDetail} onHide={() => {this.showDetailModal(false)}} className="mt-4">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Détails de la utilisateur #{this.state.utilisateur.id}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mx-3">
                            <table className="table table-sm">
                                <tbody>
                                    <tr className="row">
                                        <td className="col-sm-5">ID : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.id}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Nom : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.nom}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Prénom : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.prenom}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Sexe : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.sexe}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Pays : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.pays}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Adresse : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.adresse}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Email : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.email}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Téléphone : </td>
                                        <td className="col-sm-7">{this.state.utilisateur.telephone}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">solde : </td>
                                        <td className="col-sm-7">{Intl.NumberFormat().format(this.state.utilisateur.solde)} {this.state.utilisateur.devise}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Dernière transaction : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.utilisateur.dateDerniereTransaction}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Montant de la dernière transaction : </td>
                                        <td className="col-sm-7">{Intl.NumberFormat().format(this.state.utilisateur.montantDerniereTransaction)}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Dernière mise à jour du solde : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.utilisateur.dateDerniereMiseAJourSolde}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Dernière activité : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.utilisateur.dateActif}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Actif : </td>
                                        <td className="col-sm-7">{(this.state.utilisateur.actif==1)?<span className="bg-success px-3 py-1">Oui</span>:<span className="bg-danger px-3 py-1">Non</span>}</td>
                                    </tr>
                                    {(!this.props.isClients) &&
                                    <tr className="row">
                                        <td className="col-sm-5">Droits d'accès : </td>
                                        <td className="col-sm-7">{droitsAcces.filter(d => d.type==this.state.utilisateur.type).map(d => d.name)}</td>
                                    </tr>
                                    }
                                    {(!this.props.isClients) &&
                                    <tr className="row">
                                        <td className="col-sm-5">Appartenance : </td>
                                        <td className="col-sm-7">{(this.state.utilisateur.partenaire)?this.state.utilisateur.partenaire.entreprise:"AFRICPAY"}</td>
                                    </tr>
                                    }
                                    {(!this.props.isClients) &&
                                    <tr className="row">
                                        <td className="col-sm-5">Autorisations : </td>
                                        <td className="col-sm-7">
                                            {this.state.utilisateur.hasCashIn?"DEPÔT, ":""}
                                            {this.state.utilisateur.hasCashOut?"RETRAIT":""}
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => {this.showDetailModal(false)}}>Fermer</button>
                        {(this.state.utilisateur.actif==1)?
                        <button className="btn btn-danger" onClick={() => {this.desactiverUtilisateur()}}>Bloquer</button>:
                        <button className="btn btn-success" onClick={() => {this.activerUtilisateur()}}>Activer</button>
                        }
                    </Modal.Footer>
                </Modal>
                }
                {(this.state.approvisionnement.idClient!=0) &&
                <Modal show={this.state.showUtilisateur} onHide={() => {this.showApprovisionnementModal(false)}} className="mt-4">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Utilisateur {(this.props.isClients)?"du client":"de l'utilisateur"} {this.state.approvisionnement.nomUtilisateur}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="beneficiaire">Client</label>
                                    <input type="text" value={this.state.approvisionnement.nomUtilisateur} className="form-control border-secondary" placeholder="Nom du client" readOnly />
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="montant">Montant</label>
                                    <input type="number" name="montant" value={this.state.approvisionnement.montant} id="montant" className="form-control border-secondary" onChange={(e) => this.handleInputUtilisateur(e)} required />
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="devise">Devise</label>
                                    <select name="devise" value={this.state.approvisionnement.devise} id="devise" className="form-control border-secondary" onChange={(e) => this.handleInputUtilisateur(e)} required readOnly >
                                        <option value=""></option>
                                        {( pays.map(p => <option value={ p.devise } key={'approvisionnement-devise-'+p.devise}>{ p.devise }</option> ) )}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => {this.showApprovisionnementModal(false)}}>Fermer</button>
                        <button className="btn btn-primary" onClick={(e) => {this.approvisionneUtilisateur(e)}}>Approvisionner</button>
                    </Modal.Footer>
                </Modal>
                }
                <Modal show={this.state.showNewUtilisateur} onHide={() => {this.showNewUtilisateurModal(false)}} className="">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {(this.props.isClients)?"Nouveau client":"Nouvel utilisateur"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <select className="form-control" name="sexe" value={this.state.newUtilisateur.sexe} onChange={this.handleInputNewUtilisateur} required>
                                    <option value="Homme">Monsieur</option>
                                    <option value="Femme">Madame</option>
                                </select>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Nom</label>
                                <input className="form-control" type="text" name="nom" placeholder="Nom" value={this.state.newUtilisateur.nom} onChange={this.handleInputNewUtilisateur} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Prénom</label>
                                <input className="form-control" type="text" name="prenom" placeholder="Prénom" value={this.state.newUtilisateur.prenom} onChange={this.handleInputNewUtilisateur} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Pays</label>
                                <select className="form-control" name="pays" value={this.state.newUtilisateur.pays} onChange={this.handleInputNewUtilisateur} required>
                                    {( pays.map((p, index) => <option value={ p.name } key={'pays-'+index}>{ p.name }</option> ) )}
                                </select>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Dévise utilisée</label>
                                <select className="form-control" name="devise" value={this.state.newUtilisateur.devise} onChange={this.handleInputNewUtilisateur} required disabled>
                                    {( pays.map((p, index) => <option value={ p.devise } key={'devise-'+index}>{ p.devise }</option> ) )}
                                </select>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Adresse</label>
                                <input className="form-control" type="text" name="adresse" placeholder="Adresse" value={this.state.newUtilisateur.adresse} onChange={this.handleInputNewUtilisateur} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Téléphone</label>
                                <input className="form-control" type="number" name="telephone" placeholder="Téléphone" value={this.state.newUtilisateur.telephone} onChange={this.handleInputNewUtilisateur} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Email</label>
                                <input className="form-control" type="email" name="email" placeholder="Email" value={this.state.newUtilisateur.email} onChange={this.handleInputNewUtilisateur} />
                            </div>
                            {(!this.props.isClients) &&
                            <div className="form-group col-md-12">
                                <label>Droits d'accès</label>
                                <select className="form-control" name="type" value={this.state.newUtilisateur.type} onChange={this.handleInputNewUtilisateur} required       >
                                    {droitsAcces.map(d => <option value={d.type}>{d.name}</option>)}
                                </select>
                            </div>}
                            {(this.state.newUtilisateur.type>0 && this.state.newUtilisateur.type<10) &&
                            <div className="form-group col-md-12">
                                <label>Partenaire</label>
                                <select className="form-control" name="idPartenaire" value={this.state.newUtilisateur.idPartenaire} onChange={this.handleInputNewUtilisateur}>
                                    <option value="0">Aucun</option>
                                    {this.state.partenaires.map(partenaire => <option key={'partenaire-choix-'+partenaire.id} value={partenaire.id}>{partenaire.entreprise}</option>)}
                                </select>
                            </div>}
                            <div className="form-group col-md-12">
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" className="custom-control-input" id="hasCashOut" name="hasCashOut" checked={this.state.newUtilisateur.hasCashOut} onChange={this.handleInputNewUtilisateur} />
                                    <label className="custom-control-label" htmlFor="hasCashOut">L'utilisateur peut effectuer un retrait.</label>
                                </div>
                            </div>
                            <div className="form-group col-md-12">
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" className="custom-control-input" id="hasCashIn" name="hasCashIn" checked={this.state.newUtilisateur.hasCashIn} onChange={this.handleInputNewUtilisateur} />
                                    <label className="custom-control-label" htmlFor="hasCashIn">L'utilisateur peut effectuer un approvisionnement.</label>
                                </div>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Mot de passe</label>
                                <input className="form-control" type="password" name="pass" placeholder="Mot de passe" value={this.state.newUtilisateur.pass} onChange={this.handleInputNewUtilisateur} required />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => {this.showNewUtilisateurModal(false)}}>Fermer</button>
                        <button className="btn btn-primary" disabled={this.state.enTraitement} onClick={(e) => {this.saveNewUtilisateur(e)}}>{(!this.state.enTraitement)?"Enregistrer":"Traitement..."}</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default Utilisateurs;